import { render, staticRenderFns } from "./okButtonLabel-editor.vue?vue&type=template&id=4139c4da&scoped=true&"
import script from "./okButtonLabel-editor.vue?vue&type=script&lang=js&"
export * from "./okButtonLabel-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4139c4da",
  null
  
)

export default component.exports